<template>
  <div v-if="authState.isEmailVerified.value">
    <router-link
      :to="`/organizations/new`"
      class="important-button big"
    >
      <font-awesome-icon icon="plus" /> New Organization
    </router-link>
  </div>
  
  <div v-else>
    <div>
      <font-awesome-icon icon="exclamation-triangle" /> 
      Your email address has not been verified.
    </div>
    <div>
      Please check your inbox for the verification link.
    </div>
    <div class="link" @click="resendVerificationEmail" :disabled="resendingVerification">
      {{ resendingVerification ? 'Sending...' : 'Send a new verification email' }}
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { authState, resendVerification } from '@/scripts/services/authService';
import { handleApiError } from '@/scripts/shared-utils';

const resendingVerification = ref(false);

async function resendVerificationEmail() {
  if (resendingVerification.value) return;
  
  resendingVerification.value = true;
  try {
    const result = await resendVerification();
    if (result === true) {
      alert('Verification email sent! Please check your inbox.');
    } else {
      alert(`Error: ${result}`);
    }
  } catch (error) {
    handleApiError(error, 'resending verification email');
  } finally {
    resendingVerification.value = false;
  }
}
</script>

<style scoped>
@import '@/styles/shared-list.css';
</style>
